var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "是否多选" } },
        [
          _c("el-switch", {
            on: { change: _vm.handleChange },
            model: {
              value: _vm.activeData.multiple,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "multiple", $$v)
              },
              expression: "activeData.multiple",
            },
          }),
        ],
        1
      ),
      _c("matrix-option", { attrs: { "active-data": _vm.activeData } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }